interface ChatBubbleProps {
  role: "user" | "assistant";
  content: string;
  index: number;
}

export function ChatBubble({ role, content, index }: ChatBubbleProps) {
  const isAssistant = role === "assistant";

  return (
    <div
      data-testid={`chat-bubble-${role}-${index}`}
      className={`flex ${isAssistant ? "justify-start agent-animate-slide-left" : "justify-end agent-animate-slide-right"}`}
    >
      {isAssistant && (
        <img
          src="https://www.chickytutor.com/ui/Chickylogovector.gif?v=0"
          alt="Chicky"
          className="mr-2 mt-1 h-8 w-8 shrink-0 rounded-full border-2 border-black"
        />
      )}
      <div
        className={`max-w-[80%] rounded-2xl px-4 py-3 ${
          isAssistant
            ? "rounded-tl-none border-2 border-black bg-[#FFD700] text-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
            : "rounded-tr-none border-2 border-black bg-white text-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)]"
        }`}
      >
        <p className="whitespace-pre-wrap text-base font-medium leading-relaxed">{content}</p>
      </div>
    </div>
  );
}
